import React from 'react';
import WebsiteImage from 'components/WebsiteImage';
import Text from 'components/Core/Text';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import { GridContainer, TileContainer, Overlay, TextContainer } from './styles';

const Grid = () => {
  const { contentfulComponentCollection } = useStaticQuery(graphql`
    query {
      contentfulComponentCollection(contentful_id: { eq: "4h6b4CEqADDPB7YCQmcsSd" }) {
        components {
          ... on ContentfulImage {
            caption
            url
            image {
              ... on ContentfulAsset {
                gatsbyImageData(formats: [WEBP], width: 200, height: 200)
              }
              file {
                url
              }
            }
          }
        }
      }
    }
  `);
  const images = contentfulComponentCollection.components;

  const handleOnClick = (path) => {
    if (path) {
      dataLayer.push({
        event: 'cta clicked',
        cta_position: 'tileclick',
        cta_url: path,
      });
      navigate(path);
    }
  };

  return (
    <GridContainer>
      {images.map((i, index) => {
        return (
          <TileContainer key={`lottie-grid-${index}`} onClick={() => handleOnClick(i.url)}>
            <WebsiteImage {...i} />
            <Overlay />
            <TextContainer>
              <Text type="p">{i.caption}</Text>
            </TextContainer>
          </TileContainer>
        );
      })}
    </GridContainer>
  );
};

export default Grid;
